import * as Sentry from '@sentry/react'
import {createRouter, RouterProvider} from '@tanstack/react-router'
import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'

import UmamiScript from './lib/umami'
import {routeTree} from './routeTree.gen'

import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'

if (!import.meta.env.DEV) {
    Sentry.init({
        dsn: 'https://d254bfe7f6ac8207eb6ad750ab51a274@o4508972163268608.ingest.us.sentry.io/4510987577065472',
        sendDefaultPii: false,
        integrations: [
            // send console.warn and console.error calls as logs to Sentry
            Sentry.consoleLoggingIntegration({levels: ['warn', 'error']}),
            Sentry.replayIntegration(),
        ],
        enableLogs: true,
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
    })
}

const router = createRouter({routeTree})

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <RouterProvider router={router} />
        {import.meta.env.PROD && <UmamiScript websiteId="4c041a6b-fbed-45ab-86e9-4fc683d1872f" />}
    </StrictMode>,
)
